import reducer from './reducer';


export default reducer;

export * from './actions';
export * from './selectors';
export * from './constants';

// Named export off the reducer module (which otherwise only default-exports), so callers can keep
// importing from the `data/search` barrel like everything else here — see ATAI-278.
export { isKnownFilterField } from './reducer';
